import { Text, Stack, rem } from '@mantine/core';
import classes from './left-banner-login.module.css';

function BannerLogin() {
  return (
    <Stack align="center" justify="center">
      <Text className={classes.text} pt={rem('300px')}>
        To get started, fill out the form. After submitting, check your email to verify your account.
      </Text>
      <Text className={classes.text}>If you are a returning user, please sign in.</Text>
    </Stack>
  );
}

export { BannerLogin };
